import { makeAutoObservable, runInAction } from "mobx";
import { ITranslationsService } from "../services/api/translations-service";
import { rootContainer, TYPE } from "../services/container/root";

class TranslationsStatusStore {
    private _hasMissingTranslations: boolean = false;

    private get translationsService(): ITranslationsService { return rootContainer.get<ITranslationsService>(TYPE.TranslationsService); }

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get hasMissingTranslations(): boolean { return this._hasMissingTranslations; }

    public async load() {
        const res = await this.translationsService.getTranslationsStatus();
        runInAction(() => {
            this._hasMissingTranslations = res.has_missing_translations;
        });
    }
}

export default TranslationsStatusStore;